'use strict';
const ResultWrapper = require('./result-wrapper').ResultWrapper;

class BufferReader {

    constructor(buffer) {
        this.offset = 0;
        this.buffer = buffer;
        this.length = buffer.length;
    }

    getLength() {
        return this.length;
    }

    hasMore() {
        return this.offset < this.length;
    }

    getByte(index) {
        return this.buffer[index];
    }

    readFirstUInt8() {
        return this.buffer[0];
    }

    readLastUInt8() {
        return this.buffer[this.length - 1];
    }

    getAndIncOffset(value = 1) {
        this.offset += value;
        if (this.offset > this.length) {
            throw new Error(`read out of bounds. offset : ${this.offset - value}, read : ${value} Byte `);
        }
        return this.offset - value;
    }

    readBit(count = 1) {
        let byte = this.readUInt8();
        let values = [];
        for (let idx = 0; idx < count; idx++) {
            values[idx] = (byte >> idx) & 1;
        }
        return values;
    }

    readUInt8() {
        return this.buffer.readUInt8(this.getAndIncOffset(1));
    }

    readInt16LE() {
        return this.buffer.readInt16LE(this.getAndIncOffset(2));
    }

    readUInt16LE() {
        return this.buffer.readUInt16LE(this.getAndIncOffset(2));
    }

    readInt32LE() {
        return this.buffer.readInt32LE(this.getAndIncOffset(4));
    }

    readUInt32LE() {
        return this.buffer.readUInt32LE(this.getAndIncOffset(4));
    }

    readFloatLE() {
        return parseFloat(this.buffer.readFloatLE(this.getAndIncOffset(4)));
    }

    readFloatLEInBatch(count = 1, decimal = 0) {
        let result = [];
        for (let idx = 0; idx < count; idx++) {
            let value = this.readFloatLE();
            if (decimal) {
                value = value / Math.pow(10, decimal);
            }
            result[idx] = value;
        }
        return result;
    }

    readUInt8InBatch(count = 1) {
        let result = [];
        for (let idx = 0; idx < count; idx++) {
            result[idx] = this.readUInt8();
        }
        return result;
    }

    readInt16LEInBatch(count = 1, sign = 0, decimal = 0) {
        let result = [];
        for (let idx = 0; idx < count; idx++) {
            let value;
            if (sign) {
                value = this.readInt16LE();
            } else {
                value = this.readUInt16LE();
            }
            if (decimal) {
                value = value / Math.pow(10, decimal);
            }
            result[idx] = value;
        }
        return result;
    }

    readInt32LEInBatch(count = 1, sign = 0, decimal = 0) {
        let result = [];
        for (let idx = 0; idx < count; idx++) {
            let value;
            if (sign) {
                value = this.readInt32LE();
            } else {
                value = this.readUInt32LE();
            }
            if (decimal) {
                value = value / Math.pow(10, decimal);
            }
            result[idx] = value;
        }
        return result;
    }


    readString(length = 1) {
        return this.readBuffer(length).toString().replace(/\0/g, '');
    }

    readBuffer(length = 1) {
        return this.readRange(this.getAndIncOffset(length), this.offset);
    }

    readHexStringByLength(length = 1) {
        return this.readBuffer(length).toString('hex');
    }

    readHexString(start = 0, end = 1) {
        return this.readRange(start, end).toString('hex');
    }

    readRange(start = 0, end = 1) {
        return this.buffer.slice(start, end);
    }
}

// 读取BufferReader中的数据和16进制字符串并放到ResultWrapper中
class HexBufferReaderWrapper {

    constructor(buffer, withResult = true) {
        this.reader = new BufferReader(buffer);
        if (withResult) {
            this.result = new ResultWrapper(2);
        }
    }

    getLength() {
        return this.reader.getLength();
    }

    getOffset() {
        return this.reader.offset;
    }

    wrapWithHexStr(method, ...args) {
        let start = this.reader.offset;
        let value = method.apply(this.reader, args);
        let end = this.reader.offset;
        let hex = this.reader.readHexString(start, end);
        return [value, hex];
    }

    hasMore() {
        return this.reader.hasMore();
    }

    moveOffset(plus) {
        this.reader.getAndIncOffset(plus);
    }

    getByte(index) {
        return this.reader.getByte(index);
    }

    setAllToResult(key, value) {
        if (key) {
            this.result.setAll(key, value);
        }
    }

    readFirstUInt8(key, filter = value => value) {
        let byte = this.reader.readFirstUInt8();
        let value = [byte, byte.toString(16)];
        this.setAllToResult(key, [filter(value[0]), value[1]]);
        return value[0];
    }

    readLastUInt8(key, filter = value => value) {
        let byte = this.reader.readLastUInt8();
        let value = [byte, byte.toString(16)];
        this.setAllToResult(key, [filter(value[0]), value[1]]);
        return value[0];
    }

    readBit(count = 1, key, filter = value => value) {
        let value = this.wrapWithHexStr(this.reader.readBit, count);
        this.setAllToResult(key, [filter(value[0]), value[1]]);
        return value[0];
    }

    readUInt8(key, filter = value => value) {
        let value = this.wrapWithHexStr(this.reader.readUInt8);
        this.setAllToResult(key, [filter(value[0]), value[1]]);
        return value[0];
    }

    readInt16LE(key, filter = value => value) {
        let value = this.wrapWithHexStr(this.reader.readInt16LE);
        this.setAllToResult(key, [filter(value[0]), value[1]]);
        return value[0];
    }

    readUInt16LE(key, filter = value => value) {
        let value = this.wrapWithHexStr(this.reader.readUInt16LE);
        this.setAllToResult(key, [filter(value[0]), value[1]]);
        return value[0];
    }

    readInt32LE(key, filter = value => value) {
        let value = this.wrapWithHexStr(this.reader.readInt32LE);
        this.setAllToResult(key, [filter(value[0]), value[1]]);
        return value[0];
    }

    readUInt32LE(key, filter = value => value) {
        let value = this.wrapWithHexStr(this.reader.readUInt32LE);
        this.setAllToResult(key, [filter(value[0]), value[1]]);
        return value[0];
    }

    readFloatLE(key, filter = value => value) {
        let value = this.wrapWithHexStr(this.reader.readFloatLE);
        this.setAllToResult(key, [filter(value[0]), value[1]]);
        return value[0];
    }

    readFloatLEInBatch(count = 1, decimal = 0, key, filter = value => value) {
        let value = this.wrapWithHexStr(this.reader.readFloatLEInBatch, count, decimal);
        this.setAllToResult(key, [filter(value[0]), value[1]]);
        return value[0];
    }


    readUInt8InBatch(count = 1, key, filter = value => value) {
        let value = this.wrapWithHexStr(this.reader.readUInt8InBatch, count);
        this.setAllToResult(key, [filter(value[0]), value[1]]);
        return value[0];
    }

    readInt16LEInBatch(count = 1, sign = 0, decimal = 0, key, filter = value => value) {
        let value = this.wrapWithHexStr(this.reader.readInt16LEInBatch, count, sign, decimal);
        this.setAllToResult(key, [filter(value[0]), value[1]]);
        return value[0];
    }

    readInt32LEInBatch(count = 1, sign = 0, decimal = 0, key, filter = value => value) {
        let value = this.wrapWithHexStr(this.reader.readInt32LEInBatch, count, sign, decimal);
        this.setAllToResult(key, [filter(value[0]), value[1]]);
        return value[0];
    }

    readString(length = 1, key, filter = value => value) {
        let value = this.wrapWithHexStr(this.reader.readString, length);
        this.setAllToResult(key, [filter(value[0]), value[1]]);
        return value[0];
    }

    readBuffer(length = 1, key, filter = value => value) {
        let value = this.wrapWithHexStr(this.reader.readBuffer, length);
        this.setAllToResult(key, [filter(value[0]), value[1]]);
        return value[0];
    }

    readHexString(length = 1, key, filter = value => value) {
        let value = this.wrapWithHexStr(this.reader.readHexStringByLength, length);
        this.setAllToResult(key, [filter(value[0]), value[1]]);
        return value[0];
    }

    toString() {
        return this.reader.buffer.toString('hex');
    }

}

module.exports.BufferReader = BufferReader;
module.exports.HexBufferReaderWrapper = HexBufferReaderWrapper;



// WEBPACK FOOTER //
// ./src/lib/ucp/buffer-reader.js